import { ResponseType } from "../../../Types/ServicesType/servicesType";
import {
  MasterDataType,
  MasterTableDataType,
  SearchParamsType,
} from "./Types";
import api from "@services/apiList";
import instance from "@services/services";
const { MastersApi } = api;
export const getMastersTableData = async (
  params: SearchParamsType
): Promise<
  ResponseType<{ totalCount: number; items: MasterTableDataType[] }>
> => {
  const result = await instance.post(
    `${MastersApi.getNetworkMaster}`,
    params
  );
  return result.data;
};

export const saveMasterData = async (
  params: MasterDataType[]
): Promise<ResponseType<string>> => {
  const result = await instance.post(
    `${MastersApi.SaveNetworkMaster}`,
    params
  );
  return result.data;
};
